// extracted by mini-css-extract-plugin
export default {"generalDataWrapper":"generalData_generalDataWrapper__sgWpv","lastUpdate":"generalData_lastUpdate__444uM","lastUpdateDate":"generalData_lastUpdateDate__4tYAm"};